import { colors, alpha } from '../index'
export const globals = {
  navbarHeight: {
    mobile: 80,
    desktop: 96,
  },
  roundness: {
    sections: {
      desktop: 32,
      mobile: 24,
    },
    containers: {
      desktop: 32,
      mobile: 16,
    },
    pictures: {
      desktop: 32,
      mobile: 24,
    },
    buttons: 32,
  },
  shadows: {
    sections: {
      mobile: '0px 16px 96px rgba(0,0,0,0.04)',
      desktop: '0px 16px 96px rgba(0,0,0,0.04)',
    },
    buttons: `0px 8px 8px ${colors.black.concat(alpha[100])}`,
    containers: {},
    pictures: `0px 8px 24px ${colors.black.concat(alpha[16])}`,
  },
  spacing: {
    outside: {
      desktop: 0,
      mobile: 24,
    },
    inside: {
      desktop: 64,
      mobile: 24,
    },
    between: {
      desktop: 40,
      tablet: 96,
      mobile: 64,
    },
  },
}
